export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14496.a71f5fa6.jpg";